import { render, staticRenderFns } from "./ProductAttributeBlacklistSelector.vue?vue&type=template&id=5fe499bd&scoped=true&"
import script from "./ProductAttributeBlacklistSelector.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeBlacklistSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeBlacklistSelector.vue?vue&type=style&index=0&id=5fe499bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe499bd",
  null
  
)

export default component.exports